<style scoped>  

  @media only screen and (max-width: 360px) {
    .search-input {
      max-width: 80% !important;
    }
  }

  @media only screen and (min-width: 361px) {
    .search-input {
      max-width: 85% !important;
    }
  }

</style>

<template>

  <div>

    <div class="ui large breadcrumb">
      <div class="bold section">{{ title }}</div>
    </div>

    <bookmark-button :label="title" />

    <div class="ui divider"></div>

    <div class="ui grid">      
      <div class="ten wide computer sixteen wide tablet sixteen wide mobile column">
        <button class="ui blue button" @click="onNewRequest()">
          <i class="plus icon"></i> Nova Solicitação
        </button>
      </div>
      <div class="six wide computer sixteen wide tablet sixteen wide mobile column">
        <div class="ui basic right aligned segment no-padding no-margin">
          <div class="ui form">
            <div class="field">
              <search-input id="exam-requests-search-input" ref="searchInput" class="search-input" @onSearch="search" />
              <button class="ui icon button m-l-10" @click="$refs.filterModal.show()">
                <i class="filter icon" :class="{ red: !!$store.state.pages.filters.examRequests }"></i>
              </button>
            </div>
          </div>                        
        </div> 
      </div>      
    </div>

    <data-table id="exam-requests-dtbl" ref="dtbl" :service="service" :attributes="attributes" :fields="fields" 
      sortBy="id" :asc="false" @onRowClick="onShowRequest" />

    <filter-modal ref="filterModal" @onApply="filter" @onRemove="clearFilter" />

  </div>

</template>

<script>
  
  import FilterModal from "./filter"
  import ExamRequestService from "@/services/exam-request-service"
  import { gridPage, onlySimavet } from "@/mixins"

  export default {    

    name: "ExamRequestsPage",

    mixins: [gridPage],

    data() {
      return {     
        title: "Solicitações de Exames",   
        service: new ExamRequestService(),
        attributes: ["id", "status", "date", "vetName", "customerName", "animalName", "animalSex", "raceName", "speciesName"],
        fields: [          
          { prop: "id", label: "Número" },
          { prop: "status", label: "Status", render: this.renderStatus },
          { prop: "date", label: "Data", render: (request) => this.$formatDate(request.date) },
          { prop: "user.name", model: "User", label: "Responsável", render: (request) => request.user.name.toUpperCase(), visible: this.$isSimavet() },
          { prop: "vetName", label: "Veterinário", render: (request) => request.vetName.toUpperCase(), visible: this.$isSimavet() },
          { prop: "customerName", label: "Clínica" },
          { prop: "animalName", label: "Animal", render: this.renderAnimal },
        ],
      }
    },

    components: {
      FilterModal,
    },

    methods: {
      
      onNewRequest() {

        if (this.$isVet() && !this.$store.state.auth.user.vet) {
          this.$msg.warn("Seu usuário não está associado a um veterinário. Por favor acione a Simavet.", 8000)
          return
        }

        this.$router.push("/procs/exam-requests/new/form")
      },

      onShowRequest(data) {
        this.$router.push(`/procs/exam-requests/${data.row.id}/show`)
      },

      renderStatus(request) {

        const statusList = ExamRequestService.STATUS

        return `<i class="${statusList[request.status].icon}"></i> ${statusList[request.status].description}`
      },

      renderAnimal(request) {
        
        const { animalName, animalSex, raceName, speciesName } = request        
        const raceLabel = `<div class="ui small label">${raceName}<div class="detail">Espécie: ${speciesName}</div></div>`        
        let sexIcon = animalSex == "male" ? "mars blue icon" : "venus pink icon"

        if (animalSex == "undefined")
          sexIcon = "question circle grey icon"

        return `<i class="${sexIcon}"></i> ${animalName} ${raceLabel}`
      },
    },
  }

</script>
